export default __webpack_public_path__ + "747844a9aa11a75b6ee3a828051766ac.png";